const app = require('app');
const marionette = require('backbone.marionette'),
    M = require('shared/messages/messages');

module.exports = marionette.View.extend({
    saveChange: function(verb, noun, promiseGenerator, returnUrl, callBack) {
        if (!this.model.isValid(true)) {
            return;
        }
        let promise = promiseGenerator();
        this.waitOn(promise, verb);
        this.lockFormOn(promise);
        promise.done(function() {
            app.notifySuccess(M.saved());
            this.onSaveSuccess(returnUrl);
            if (_.isFunction(callBack)) {
                callBack.apply(this, arguments);
            }
        }.bind(this));
        promise.fail(function(response) {
            if (this.hasServerValidationFailures(response)) {
                this.showServerValidationErrors(response);
                return;
            }
            app.notifyError('Error');
        }.bind(this));
        return promise;
    },
    onSaveSuccess: function(returnUrl) {
        if (returnUrl === false){
            return;
        }
        if (returnUrl) {
            window.location.hash = returnUrl;
        }
        else {
            app.navigateBack();
        }
    }
});
